import { API_END_POINTS } from "../../API_END_POINTS";
import axios from "axios";

const productRivewUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.productRivew}`;

export const addProductRivewService = async (reviewData) => {
  try {
    const response = await axios.post(productRivewUrl, reviewData, {
      headers: {
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "application/json", // Ensure JSON is properly sent
      },
    });
    return response.data; // Return the response for further handling
  } catch (error) {
    console.error("Error Adding product review:", error);
    throw error; // Throw the error for rejection in the async thunk
  }
};
